import {ALLOWED_NON_TOKEN_COLORS} from './_constants';

export const color = {
  color: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  textColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  fill: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  stroke: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Color = typeof color;
